import { Mutator } from 'final-form';

import { FormValues } from './validator';

export const addScope: Mutator<FormValues> = (args, state, utils) => {
  const [scope] = args;
  utils.changeValue(state, 'scopes', (prev) => [...prev, scope]);
};

export const deleteScope: Mutator<FormValues> = (args, state, utils) => {
  const [scope] = args;
  utils.changeValue(state, 'scopes', (prev) => {
    return prev.filter((item: string) => item !== scope);
  });
};
